import React from "react";
import { withTranslation } from "react-i18next";
import localforage from "localforage";
import moment from "moment";

import ContainerNavs from "@/react-components/ContainerNavs";
import SuggestList from "@/react-components/SuggestList";
import Dropdown from "@/react-components/Dropdown";
import SearchResult from "@/react-components/SearchResult";
import DateInput from "@/react-components/DateInput";
import { api } from "@/utils/api";
import { trim, isEmpty, setUrlParameter } from "@/utils";
import { cookieKeyEnum } from "@/utils/enum";
import config from "@/utils/config";
import url from "@/utils/url";

class LibrarySearchSection extends React.Component {
  constructor(props) {
    super(props);

    this.deliveryDateList = config.deliveryDateList();

    this.navList = config.libraryNavList();

    this.original = {
      keyword: "",
      selectTagGroup: null,
      selectTag: null,
      tagDisabled: true,
      selectDeliveryDate: this.deliveryDateList[0],
      startDate: null,
      endDate: null,
      pageParams: {
        pageIndex: 1,
        pageSize: 8,
        totalPage: 1,
      },
      historyDisplay: true,
      list: [],
    };

    this.state = {
      ...JSON.parse(JSON.stringify(this.original)),
      tagList: [],
      brightenKeyword: "",
      historyList: [],
      list: [],
    };
  }

  componentDidMount() {
    this.fetchTagList();
    this.fetchHistoryList();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props?.router?.location?.state !==
        nextProps?.router?.location?.state &&
      nextProps?.router?.location?.pathname === url.librarySearch
    ) {
      this.fetchTagList(nextProps);
    }
  }

  fetchTagList = (props = this.props) => {
    api.dictionary
      .getTagLibraryList()
      .then((response) => {
        this.setState(
          {
            tagList: this.loopTags(response),
          },
          () => {
            this.fetchParams(props);
          }
        );
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchHistoryList = () => {
    localforage
      .getItem(cookieKeyEnum.libraryHistory)
      .then((value) => {
        this.setState({ historyList: value });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchData = (page = 1) => {
    const { pageParams } = this.state;
    const params = this.createParams(page);
    api.library
      .search(params)
      .then((response) => {
        pageParams.totalPage = parseInt(
          (response.totalCount + pageParams.pageSize - 1) / pageParams.pageSize
        );
        this.saveHistory({ ...params });
        this.setState({
          pageParams,
          list: response.list,
          historyDisplay: false,
          brightenKeyword: params.keyWord,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            page: params.pageIndex,
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  inputChange = (element) => {
    this.setState({
      keyword: element.target.value,
    });
  };

  tagGroupChange = (item, callBack) => {
    this.setState(
      {
        selectTagGroup: item,
        tagDisabled:
          !item ||
          item.value === "" ||
          !item.children ||
          item.children.length === 0,
        selectTag: null,
      },
      callBack
    );
  };

  tagChange = (item) => {
    this.setState({ selectTag: item });
  };

  deliveryDateChange = (item) => {
    if (item.value === "5") {
      this.setState({ selectDeliveryDate: item });
    } else {
      this.setState({
        selectDeliveryDate: item,
        startDate: null,
        endDate: null,
      });
    }
  };

  startDateChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  endDateChange = (date) => {
    this.setState({
      endDate: date,
    });
  };

  // 「Enter」キーの押下、検索を実行
  onKeyup = (e) => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  search = (page = 1) => {
    this.go(this.createParams(page));
  };

  historyClick = (params) => {
    this.go(params);
  };

  go = (params) => {
    const {
      router: {
        history: { push },
      },
    } = this.props;
    push({
      pathname: url.librarySearch,
      state: { params },
    });
  };

  fetchParams = (props = this.props) => {
    const {
      router: {
        location: { state },
      },
    } = props;
    const original = JSON.parse(JSON.stringify(this.original));
    if (state) {
      let params;
      if (state?.selectTag) {
        const { pageParams, selectDeliveryDate } = original;
        params = {
          ...pageParams,
          keyWord: "",
          timeType: selectDeliveryDate.value,
          tags: state?.selectTag,
        };
      } else if (state?.params) {
        params = state?.params;
      }
      this.analysisParams(params, () => {
        setTimeout(() => {
          this.fetchData(params?.pageIndex);
        }, 0);
      });
    } else {
      this.fetchHistoryList();
      this.setState(original);
    }
  };

  analysisParams = (data, callBack) => {
    if (data) {
      const { tagList } = this.state;
      if (data.tags !== undefined) {
        let tagGroup, tag;
        if (data.tags.indexOf("_") !== -1) {
          const temp = data.tags.split("_");
          tagGroup = temp[0];
          tag = temp[1];
        } else {
          tagGroup = data.tags;
        }
        const filterTagGroup = tagList.filter(
          (item) => item.value === tagGroup
        )[0];
        this.tagGroupChange(filterTagGroup, () => {
          if (tag !== undefined) {
            const filterTag = filterTagGroup.children.filter(
              (item) => item.value === data.tags
            )[0];
            this.tagChange(filterTag);
          }
        });
      }
      const filterDeliveryDate = this.deliveryDateList.filter(
        (item) => item.value === data.timeType
      )[0];
      this.deliveryDateChange(filterDeliveryDate);
      if (data.timeType === "5") {
        this.setState({
          startDate: data.publicDateStart,
          endDate: data.publicDateEnd,
        });
      }
      this.setState({ keyword: data.keyWord }, callBack);
    }
  };

  createParams = (page = 1) => {
    const {
      pageParams,
      keyword,
      selectTagGroup,
      selectTag,
      selectDeliveryDate,
      startDate,
      endDate,
    } = this.state;
    pageParams.pageIndex = page;
    let params = {
      pageSize: pageParams.pageSize,
      pageIndex: page,
      keyWord: trim(keyword),
      timeType: selectDeliveryDate.value,
    };
    if (selectTagGroup) {
      params.tags = selectTagGroup.value;
    }
    if (selectTag && !isEmpty(selectTag.value)) {
      params.tags = selectTag.value;
    }
    if (selectDeliveryDate.value === "5") {
      params = {
        ...params,
        publicDateStart: startDate
          ? new Date(moment(startDate).startOf("day").format("YYYY-MM-DD"))
          : "",
        publicDateEnd: endDate
          ? new Date(moment(endDate).startOf("day").format("YYYY-MM-DD"))
          : "",
      };
    }
    return params;
  };

  loopTags = (list, parentItem) => {
    if (list && list.length > 0) {
      return list.map((item) => {
        return {
          text: item.text,
          value: parentItem ? `${parentItem.tcode}_${item.tcode}` : item.tcode,
          children: this.loopTags(item.children, item),
        };
      });
    }
  };

  saveHistory = (data) => {
    if (data.keyWord) {
      localforage
        .getItem(cookieKeyEnum.libraryHistory)
        .then((value) => {
          let temp = value ? [...value] : [];
          temp = temp.filter((item) => item.content !== data.keyWord);
          temp.unshift({ ...data, content: data.keyWord, pageIndex: 1 });
          if (temp.length > 5) {
            temp = temp.slice(0, 5);
          }
          localforage
            .setItem(cookieKeyEnum.libraryHistory, temp)
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  render() {
    const {
      tagList,
      selectTagGroup,
      /* selectTag, */
      selectDeliveryDate,
      /* tagDisabled, */
      keyword,
      brightenKeyword,
      startDate,
      endDate,
      list,
      historyDisplay,
      historyList,
      pageParams: { totalPage, pageIndex },
    } = this.state;

    const { t } = this.props;
    const dateInputDisabled =
      !selectDeliveryDate || selectDeliveryDate.value !== "5";

    return (
      <section>
        <ContainerNavs navs={this.navList} searchActive={true} />
        <div className="search-library-section">
          <div className="search-library-form flex-row flex-wrap">
            <div className="search-form-item-wrap flex-column">
              <label>{t("TCLs0011_title")}</label>
              <div className="search-input">
                <img src={require("@/assets/images/search-lends.svg")} alt="" />
                <input
                  type="text"
                  onChange={this.inputChange}
                  value={keyword}
                  maxLength="50"
                  placeholder={t("TCMS01012_placeholder")}
                  autoComplete="off"
                  onKeyUp={this.onKeyup}
                />
              </div>
            </div>
            <div className="search-form-item-wrap flex-column">
              <label>{t("TCMS01012_tagGroup")}</label>
              <Dropdown
                list={tagList}
                selected={selectTagGroup}
                placeholder={t("TCMS01012_selectPlaceholder")}
                onChange={this.tagGroupChange}
              />
            </div>
            {/* <div className="search-form-item-wrap flex-column">
              <label>{t("TCMS01012_tagValue")}</label>
              <Dropdown
                list={(selectTagGroup && selectTagGroup.children) || []}
                selected={selectTag}
                disabled={tagDisabled}
                placeholder={t("TCMS01012_selectPlaceholder")}
                onChange={this.tagChange}
              />
            </div> */}
            <div className="search-form-item-wrap flex-column">
              <label>{t("TCMS01012_deliveryDate")}</label>
              <Dropdown
                list={this.deliveryDateList}
                selected={selectDeliveryDate}
                other={false}
                placeholder={t("TCMS01012_selectPlaceholder")}
                onChange={this.deliveryDateChange}
              >
                <DateInput
                  className="date-input"
                  value={startDate}
                  maxDate={endDate || new Date()}
                  onChange={this.startDateChange}
                  disabled={dateInputDisabled}
                />

                <DateInput
                  className="date-input"
                  value={endDate}
                  minDate={startDate || new Date()}
                  onChange={this.endDateChange}
                  disabled={dateInputDisabled}
                />
              </Dropdown>
            </div>
          </div>
          <div className="search-library-form-footer flex-row-center">
            <div
              className="submit-btn flex-row-center"
              onClick={() => this.search()}
              tabIndex="0"
            >
              {t("TCMS01012_search")}
            </div>
          </div>
        </div>
        <div className="search-line" />
        {historyDisplay ? (
          <SuggestList itemList={historyList} onClick={this.historyClick} />
        ) : (
          <SearchResult
            list={list}
            totalPage={totalPage}
            pageIndex={pageIndex}
            onChange={this.search}
            keyword={brightenKeyword}
          />
        )}
      </section>
    );
  }
}

export default withTranslation()(LibrarySearchSection);
